module.exports = __webpack_public_path__ + "img/bx-right-arrow-alt.3ea49094.svg";